/* eslint-disable @next/next/no-img-element */
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Heart from "../../../../icons/Heart";
import LikedIcon from "../../../../icons/LikedIcon";
import Dot from "../../../../icons/Dot";
import VerifiedHammer from "../../../../icons/VerifiedHammer";
import ChartLineUp from "../../../../icons/ChartLineUp";
import MapPin from "../../../../icons/MapPin";
import CaretDown from "../../../../icons/CaretDown";
import WhatsAppIcon2 from "../../../../icons/WhatsAppIcon2";
import ContactButton from "../../../../shadcn/components/custom/ContactButton";
import useDimensions from "../../../../hoc/useDimensions";
import ChevronUpSvg from "../../../../icons/ChevronUpSvg";
import { getWatermarkedImgixUrl, shortlistProperty } from "services";
import CustomModalLayout from "../../Auth/CustomModalLayout";
import AcknowledgementCard from "../../../../shadcn/components/custom/AcknowledgementCard";
import { AuthModalWrapper } from "../../Auth/AuthModal";

// success tagStyle ="bg-[#F2FFEA]"

interface PropertyCardProps {
  assetPath: string;
  className?: string;
  imgClasses?: string;
  isVerified?: boolean;
  isLiked?: boolean;
  isTagged?: boolean;
  tag?: string;
  tagStyle?: string;
  tagNumber?: any;
  tagText?: any;
  showTagText: boolean;
  showPrice: boolean;
  price: string | number;
  priceTag: string;
  listingId: string;
  location: string;
  propertyType: string;
  carpetArea: string;
  deadlineDate: string;
  auctionDate: string;
  propertyInfo: string;
  sellerName: string;
  sellerIcon?: JSX.Element;
  whatsAppHandler: () => void;
  contactHandler: () => void;
  sortingHandler: () => void;
  showHeart?: boolean;
  propertyData: any;
}

export default function PrivatePropertyCard({
  assetPath,
  isVerified = false,
  isLiked = false,
  isTagged = false,
  className,
  imgClasses,
  tag,
  tagStyle,
  tagNumber,
  tagText,
  showTagText = true,
  showPrice = true,
  price,
  priceTag,
  listingId,
  location,
  propertyType,
  carpetArea,
  deadlineDate,
  auctionDate,
  propertyInfo,
  sellerName,
  sellerIcon,
  propertyData,
  whatsAppHandler,
  contactHandler,
  sortingHandler,
  showHeart = true,
}: PropertyCardProps) {
  const userToken = useSelector((state: any) => state.auth.accessToken);
  const [showMore, setShowMore] = useState(false);
  const [isTextExceeded, setIsTextExceeded] = useState(false);
  const [acknowledgementOpen, setAcknowledgementOpen] = useState(false);
  const [acknowledgementDetails, setAcknowledgementDetails] = useState({
    name: "",
    mobile: "",
    email: "",
  });
  const [maxLength, setMaxLength] = useState(60);
  const { ref, dimensions } = useDimensions();

  const [interestedCount, setInterestedCount] = useState<number>(0);
  const isLoggedIn = useSelector((state: any) => state.auth.user);
  const [authModelOpen, setAuthModelOpen] = useState(false);

  useEffect(() => {
    if (propertyData.interested_count) {
      setInterestedCount(propertyData.interested_count);
    }
  }, [propertyData.interested_count]);

  useEffect(() => {
    const maxTextLength =
      dimensions.width > 900 ? 105 : dimensions.width > 357 ? 55 : 48;
    setMaxLength(maxTextLength);
    setIsTextExceeded(propertyInfo?.length > maxTextLength);
  }, [dimensions, propertyInfo?.length]);

  if (!dimensions) return null;

  const toggleShowMore = () => setShowMore((prev) => !prev);

  const handleClick = () => {
    window.open(`/private-properties/${listingId}`, "_blank");
  };

  const handleShortListed = async (event: React.MouseEvent) => {
    event.stopPropagation();
    try {
      if (userToken) {
        const data: any = await shortlistProperty(
          propertyData.uuid,
          propertyData.interested_count,
        );
        setInterestedCount(data.interested_count);
      } else {
        setAuthModelOpen(true);
      }
    } catch (error) {
      console.log("check error", error);
    }
  };

  const handleWhatsappClick = () => {
    const clientNumber = "+918370969696";
    const baseurl = window.location.href.split("/").filter(Boolean)[1];
    const link = "https://" + baseurl + `/auction-properties/${listingId}`;
    const whatsappMsg = `Hi Auctionbazaar,\n\nI am interested in knowing more about this property\n\n${link}`;

    window.open(
      `https://wa.me/${clientNumber}?text=${encodeURI(whatsappMsg)}`,
      "_blank",
    );
  };

  return (
    <section
      onClick={handleClick}
      className={`${
        authModelOpen || acknowledgementOpen
          ? ""
          : "hover:drop-shadow-lg hover:scale-[1.001]   hover:duration-300 hover:ease-out hover:cursor-pointer"
      }`}
    >
      <main
        ref={ref}
        className={
          className
            ? className
            : "bg-brand-lightPink flex flex-col md:flex-row max-w-[358px] md:max-w-[951px] 2xl:lg:max-w-[1251px] lg:relative   clip-path-mobileClipPolygonTopRight md:clip-path-webClipPolygonTopRight"
        }
      >
        <section className="relative cursor-pointer">
          <img
            src={
              propertyData?.posted_properties_raw_data?.propertyPhotos?.length >
              0
                ? getWatermarkedImgixUrl(
                    `${process.env.NEXT_PUBLIC_IMAGIX_URL}/${propertyData?.posted_properties_raw_data?.propertyPhotos[0].id}`,
                  )
                : assetPath
            }
            alt="property image"
            className={`w-full md:w-[293px]  h-[177px] md:h-[252px] z-0 ${imgClasses}`}
          />
          {isVerified && (
            <div className="absolute left-3 top-3 z-10">
              <VerifiedHammer />
            </div>
          )}
          {isTagged && (
            <div className="absolute bottom-0 left-0 z-10 bg-gradient-to-t from-black to-[#00000000] w-full pt-4 pb-3 lg:pt-8">
              {tag && (
                <div
                  className={`ml-2 pl-1 pr-5 text-xs font-openSans font-semibold uppercase bg-[#F1EAFF] justify-self-start py-[2px] ${tagStyle}`}
                  style={{
                    clipPath:
                      "polygon(0% 0%, 85% 0%, 100% 100%, 100% 100%, 0% 100%)",
                  }}
                >
                  {tag || "Seen"}
                </div>
              )}
              {showTagText && (
                <div className="flex items-start gap-2 px-2 pt-2 text-xs font-openSans font-bold text-white">
                  <ChartLineUp />
                  <div>{`${tagNumber || 100}+ ${
                    tagText || "people shortlist this property"
                  }`}</div>
                </div>
              )}
            </div>
          )}
          {showHeart && (
            <div
              className="absolute right-[37px] top-[10px] z-10 lg:hidden cursor-pointer"
              onClick={handleShortListed}
            >
              {isLiked ? <LikedIcon border="#fff" /> : <Heart border="#fff" />}
            </div>
          )}
        </section>

        <section className="py-4 lg:py-4 px-3 lg:px-0 lg:pl-5 lg:flex-1 lg:pr-[51px]">
          <div className="flex items-center justify-between lg:pr-10">
            {showPrice && (
              <div className="flex items-center">
                <span className="font-openSans font-semibold text-xl lg:text-2xl leading-normal text-brand-textBlack">
                  ₹{price}
                </span>
                <span className="font-openSans font-semibold text-[10px] lg:text-xs leading-normal uppercase text-brand-headingBlue pl-[6px] lg:pl-[10px] mt-[5px] lg:mt-0">
                  BASE PRICE
                </span>
              </div>
            )}
            <div className="py-1 px-3 lg:px-4 border-[0.5px] rounded-full border-brand-textLightGrey flex items-center">
              <Dot />
              <span className="text-[10px] lg:text-sx font-openSans pl-3 font-normal text-brand-textBlack">
                ID {listingId}
              </span>
            </div>
          </div>

          <div className="flex pt-[10px] lg:pt-[6px] lg:items-center">
            <MapPin />
            <span className="px-1 font-openSans text-xs lg:text-sm text-brand-textLightGrey font-normal capitalize">
              {location}
            </span>
            <ul className="list-disc pl-4 lg:pl-6 font-openSans text-xs lg:text-sm text-brand-textLightGrey font-normal capitalize">
              <li>{propertyType}</li>
            </ul>
          </div>

          <div className="pt-[21px] lg:pt-[19px] lg:max-w-[413px] flex">
            <div className="  flex-[10] flex flex-col justify-start">
              <div>
                <h4 className="font-openSans text-[10px] lg:text-xs text-brand-textLightGrey font-normal leading-normal">
                  Area
                </h4>
                <p className="font-openSans text-[10px] lg:text-xs font-semibold text-brand-textBlack leading-normal mt-1">
                  {carpetArea} sq.ft
                </p>
              </div>
            </div>
          </div>

          <div
            className="pt-[22px] lg:pt-[21px] flex items-start relative"
            onClick={(e: any) => {
              if (isTextExceeded) {
                e.stopPropagation();
              }
            }}
          >
            <p
              className={`text-[10px] font-normal text-brand-textLightGrey leading-4 tracking-wide capitalize`}
            >
              {isTextExceeded && !showMore
                ? `${propertyInfo.substring(0, maxLength)}...`
                : !isTextExceeded
                ? propertyInfo
                : `${propertyInfo.substring(0, maxLength)}...`}
            </p>
            <div
              className={`text-[10px] font-normal text-brand-textLightGrey leading-4 tracking-wide capitalize bg-white p-2 lg:p-4 rounded-lg cursor-default ${
                isTextExceeded && showMore ? "" : "hidden"
              } flex absolute items-center lg:items-start -top-10 lg:-top-12 ml-0 lg:ml-4 break-normal shadow-sm`}
            >
              <span>{isTextExceeded && showMore && propertyInfo}</span>
              {isTextExceeded && (
                <span
                  onClick={() => setShowMore(false)}
                  className="cursor-pointer p-1 lg:p-2 bg-[#EEE] rounded-full"
                >
                  <ChevronUpSvg width={16} height={16} />
                </span>
              )}
            </div>
            {isTextExceeded && !showMore && (
              <span onClick={toggleShowMore} className="cursor-pointer ">
                <CaretDown />
              </span>
            )}
          </div>

          <div className="flex justify-end mt-6 lg:mt-5">
            <div
              className="flex justify-end items-center"
              onClick={(e: any) => {
                e.stopPropagation();
                handleWhatsappClick();
              }}
            >
              <span className="cursor-pointer lg:hidden">
                <WhatsAppIcon2 />
              </span>
              <span className="cursor-pointer hidden lg:block">
                <WhatsAppIcon2 width={32} height={32} />
              </span>
              <span
                onClick={(e) => e.stopPropagation()}
                className="pl-4 lg:pl-5"
              >
                <ContactButton
                  onClickHandler={contactHandler}
                  setAuthModelOpen={setAuthModelOpen}
                  propertyData={propertyData}
                  allowRedirect={true}
                  listingId={listingId}
                  setAcknowledgementOpen={setAcknowledgementOpen}
                  setAcknowledgementDetails={setAcknowledgementDetails}
                />
              </span>
            </div>
          </div>
        </section>
        {showHeart && (
          <div
            className="absolute hidden lg:block right-[58px] top-[20px] z-10 cursor-pointer"
            onClick={handleShortListed}
          >
            {isLiked ? <LikedIcon border="#fff" /> : <Heart border="#2D2D2D" />}
          </div>
        )}
      </main>
      <div onClick={(e) => e.stopPropagation()}>
        <CustomModalLayout
          open={acknowledgementOpen}
          onClose={() => setAcknowledgementOpen(false)}
          className="pt-8 pb-[30px]"
          childrenClassName="pl-4 pr-6"
        >
          <AcknowledgementCard
            name={
              acknowledgementDetails.name ? acknowledgementDetails.name : ""
            }
            message="Thank you for your interest in the property. Our team will connect with you soon to provide further details."
            hideBottomActions={true}
            contactInfo={{
              mobileNumber: `+91 ${acknowledgementDetails?.mobile || ""}`,
              email: acknowledgementDetails?.email || "",
            }}
            handleInterested={() => {}}
            handleNotInterested={() => {}}
          />
        </CustomModalLayout>
      </div>
      <div onClick={(e) => e.stopPropagation()}>
        <AuthModalWrapper
          userLoggedin={isLoggedIn}
          authModelOpen={authModelOpen}
          setAuthModelOpen={setAuthModelOpen}
        />
      </div>
    </section>
  );
}
